module.exports = __webpack_public_path__ + "static/media/SF UI Display Bold.28e48f1f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Bold.woff2
// module id = 217
// module chunks = 0